import React, { useEffect, useState } from 'react';
import routes from 'app/routes';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { useContext as useUsersContext } from 'components/Users/Context';

import ErrorBoundary from 'components/new_ui/Errors/ErrorBoundary';

import { ContextProvider as ProgramContext } from 'components/Members/Programs/Views/Show/Context';
import SessionSchedule from 'components/Members/Schedule/Views/New/Index';
import SessionSummary from 'components/Members/Schedule/Views/Summary/Index';
import TalentAssessments from 'components/Members/TalentAssessment/Views/New/Index';
import TalentAssessmentsShow from 'components/Members/TalentAssessment/Views/Show/Index';
import GrowthReportShow from 'components/Members/GrowthReport/Views/Show/Index';
import BuyOrSkip from 'components/Members/Schedule/Views/BuyOrSkip/Index';
import EditTimeZone from 'components/Members/Profile/MemberInfo/Edit/TimeZone';
import WebView from 'components/WebView/Index';
import NewChooseType from 'components/Members/Programs/Views/New/ChooseNewProgramType/Index';
import List from './Views/List/Index';
import Show from './Views/Show/Index';
import Share from './Views/Show/Share/Index';

import SelectCoach from './Views/New/SelectCoach/Index';
import NewProgram from './Views/New/Index';
import NewAiProgram from './Views/NewAi/Index';
import LearningStyle from './Views/New/LearningStyle/Index';
import MyPreferences from './Views/New/MyPreferences/Index';
import OrderTopics from './Views/New/OrderTopics/Index';
import AiOrderTopics from './Views/NewAi/OrderTopics/Index';
import Confirm from './Views/New/Confirm/Index';
import AiConfirm from './Views/NewAi/Confirm/Index';
import CoachFeedback from './Views/CoachFeedback/Index';
import ProgramFeedback from './Views/ProgramFeedback/Index';

import AiGoals from './Views/NewAi/Goals/Index';
import PrepareProgram from './Views/NewAi/BuildProgram/Index';

import ChangeTopic from './Views/Show/ChangeTopic/Index';
import ChangeCoach from './Views/Show/ChangeCoach/Index';
import ChooseNewCoach from './Views/ChooseNewCoach/Index';

import NewProgramTalentAssessment from './Views/New/TalentAssessment/Index';
import NewProgramTalentAssessmentShow from './Views/New/TalentAssessmentShow/Index';

import StepContent from './Views/Show/StepResources/Index';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  const [refreshKey, setRefreshKey] = useState(0);

  const refreshParent = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  const router = createBrowserRouter([
    {
      path: routes.members.programs.index,
      element: <List />,
    },
    {
      path: routes.members.programs.show(),
      element: <ProgramContext><Show key={refreshKey} /></ProgramContext>,
      children: [{
        path: routes.members.programs.program.share,
        element: <Share />,
      }, {
        path: routes.members.programs.program.step.changeTopic(),
        element: <ChangeTopic />,
      }, {
        path: routes.members.programs.program.changeCoach,
        element: <ChangeCoach />,
      },
      {
        path: routes.members.programs.program.step.buyOrSkip(),
        element: <BuyOrSkip refreshParent={refreshParent} />,
      },
      ],
    },
    {
      path: routes.members.programs.chooseType,
      element: <NewChooseType />,
    },
    {
      path: routes.members.programs.new.index,
      element: <ProgramContext><NewProgram /></ProgramContext>,
      children: [
        {
          path: routes.members.programs.new.orderTopics(),
          element: <OrderTopics />,
          children: [{
            path: routes.members.programs.new.setTopic(),
            element: <ChangeTopic />,
          }],
        },
        {
          path: routes.members.programs.new.talentAssessment(),
          element: <NewProgramTalentAssessment />,
        },
        {
          path: routes.members.programs.new.talentAssessmentShow(),
          element: <NewProgramTalentAssessmentShow />,
        },
        {
          path: routes.members.programs.new.learningStyle(),
          element: <LearningStyle />,
        },
        {
          path: routes.members.programs.new.myPreferences(),
          element: <MyPreferences />,
        },
        {
          path: routes.members.programs.new.selectCoach(),
          element: <SelectCoach />,
        },
        {
          path: routes.members.programs.new.confirm(),
          element: <Confirm />,
        },
        {
          path: routes.members.programs.new.webview,
          element: <WebView />,
        },
      ],
    },
    {
      path: routes.members.programs.new_ai.index,
      element: <ProgramContext><NewAiProgram /></ProgramContext>,
      children: [
        {
          path: routes.members.programs.new_ai.goals,
          element: <AiGoals />,
        },
        {
          path: routes.members.programs.new_ai.prepareProgram,
          element: <PrepareProgram />,
        },
        {
          path: routes.members.programs.new_ai.orderTopics(),
          element: <AiOrderTopics />,
          children: [{
            path: routes.members.programs.new_ai.setTopic(),
            element: <ChangeTopic />,
          }],
        },
        {
          path: routes.members.programs.new_ai.confirm(),
          element: <AiConfirm />,
        },
        {
          path: routes.members.programs.new_ai.webview,
          element: <WebView />,
        },
      ],
    },
    {
      path: routes.members.programs.chooseNewCoach(),
      element: <ChooseNewCoach />,
    },
    {
      path: routes.members.programs.coachFeedback(),
      element: <CoachFeedback />,
    },
    {
      path: routes.members.programs.programFeedback(),
      element: <ProgramFeedback />,
    },
    {
      path: routes.members.programs.talentAssessments(),
      element: <TalentAssessments />,
    },
    {
      path: routes.members.programs.talentAssessmentsShow(),
      element: <TalentAssessmentsShow />,
    },
    {
      path: routes.members.programs.growthReportShow(),
      element: <GrowthReportShow />,
    },
    {
      path: routes.members.steps.schedule(),
      element: <SessionSchedule />,
      children: [
        {
          path: routes.members.steps.timezone(),
          element: <EditTimeZone refreshParent={refreshParent} />,
        },
        {
          path: routes.members.steps.buyOrSkipSchedule(),
          element: <BuyOrSkip refreshParent={refreshParent} />,
        },
      ],
    },
    {
      path: routes.members.steps.scheduleSummary(),
      element: <SessionSummary />,
    },
    {
      path: routes.members.steps.content(),
      element: <StepContent />,
      errorElement: <ErrorBoundary />,
    },
    {
      path: routes.members.webview.finish,
      element: <WebView />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}
